import { render, staticRenderFns } from "./NotificationsDropdown.vue?vue&type=template&id=1425040e&scoped=true"
import script from "./NotificationsDropdown.vue?vue&type=script&lang=js"
export * from "./NotificationsDropdown.vue?vue&type=script&lang=js"
import style0 from "./NotificationsDropdown.vue?vue&type=style&index=0&id=1425040e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1425040e",
  null
  
)

export default component.exports